import React from 'react'
import { Button } from '@/components/ui/button'
import type { ChartType } from '@shared/schemas/chart'
import { CHART_TYPE_CONFIG } from '../../lib/chartUtils'

interface ChartTypeSelectorProps {
  currentType: ChartType
  onTypeChange: (type: ChartType) => void
  disabled?: boolean
  className?: string
}

const ChartTypeSelector: React.FC<ChartTypeSelectorProps> = ({
  currentType,
  onTypeChange,
  disabled = false,
  className = ''
}) => {
  return (
    <div className={`flex items-center gap-0.5 p-1 bg-slate-200 dark:bg-slate-700 rounded-lg border border-slate-300 dark:border-slate-600 -mt-1 ${className}`}>
      {CHART_TYPE_CONFIG.map((chartTypeOption) => {
        const Icon = chartTypeOption.icon
        const isActive = currentType === chartTypeOption.id
        
        return (
          <Button
            key={chartTypeOption.id}
            variant="ghost"
            size="sm"
            onClick={() => onTypeChange(chartTypeOption.id)}
            disabled={disabled}
            title={chartTypeOption.name}
            className={`h-8 w-8 p-0 rounded-md transition-all ${
              isActive 
                ? 'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90' 
                : 'text-slate-600 dark:text-slate-300 hover:bg-slate-300 dark:hover:bg-slate-600 hover:text-slate-900 dark:hover:text-slate-100'
            }`}
          >
            <Icon className="h-4 w-4" />
          </Button>
        )
      })}
    </div>
  )
}

export default ChartTypeSelector 